import React from "react";

export default function DetailedReport() {
    return (
        <div>DetailedReport</div>
    )
}
